<template>
  <b-modal id="reservation-export-modal">
    <div class="reservation-export-modal px-3">
      <div class="text-center">
        <img
          src="@/assets/images/icons/popup-success-icon.svg"
          alt="popup vehicle"
          class="mb-4"
        />
        <div class="title-lg  mb-1">{{ $t("export-reservations") }}</div>
        <div class="desc-sm mb-4">{{ $t("export-processed-msg") }}</div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.reservation-export-modal {
  padding: 3rem 0rem;
}
</style>